export default "__VITE_ASSET__x8w79L6c__"